import { Place } from '../Place';

export default function isPlace(maybePlace: any): maybePlace is Place {
  return maybePlace instanceof Place;
}
